import {Component, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {Contact} from '../../model/contact';
import {Product} from '../../model/product';
import {FaqCategory} from '../../model/FaqCategory';
import {FaqCategoryService} from '../../services/faq-category.service';
import {ToastrService} from 'ngx-toastr';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {SearchBarComponent} from "../../components/common/search-bar/search-bar.component";
import {BadgeComponent} from "../../components/common/badge/badge.component";

import {AdminPageModelComponent} from "../../components/admin/admin-page-model/admin-page-model.component";
import {DynamicModalFormComponent} from "../../components/common/dynamic-modal-form/dynamic-modal-form.component";
import {
  SelectBadgeFieldComponent
} from "../../components/common/fields/select-badge-field/select-badge-field.component";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {DynamicTableComponent} from "../../components/common/dynamic-table/dynamic-table.component";
import {SpinnerComponent} from "../../components/common/spinner/spinner.component";
import {FieldDefinition} from "../../model/field-definition";

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    imports: [
    AdminPageModelComponent,
    FaIconComponent,
    SpinnerComponent,
    SearchBarComponent,
    DynamicTableComponent,
    BadgeComponent,
    DynamicModalFormComponent,
    SelectBadgeFieldComponent,
    ReactiveFormsModule
],
    styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  error = false;
  load = true;
  allContacts = [];
  contacts: Contact[];
  crmUrl: string;
  search: string;
  categories: FaqCategory[];
  selectedCategory: FaqCategory;

  toActivate: Contact;
  toDisable: Contact;
  form: FormGroup = new FormGroup({'categories': new FormControl()});
  question;

  tableaHeaders = [
    {
      label: 'Nom',
      sortable: true,
      property: 'lastname'
    },
    {
      label: "Mail",
      sortable: true,
      property: 'email',
    },
    {
      label: 'Compte',
      sortable: true,
      property: 'account.name',
      customSort: (a, b) => !a.account ? -1 : !b.account ? 1 :a.account.name.localeCompare(b.account.name),
    },
    { label: 'Produits' },
    { label: 'Référent Portail' },
    { label: 'Actif' }
  ]

  tableActions = [
    {
      icon: 'sync-alt',
      eventHandler: (item) =>  this.toActivate = item,
      cssClass: 'text-info',
      tooltip: 'Réactiver',
      condition: (item) => !item.enabled
    },
    {
      icon: 'user-slash',
      eventHandler: (item) =>  this.toDisable = item,
      cssClass: 'text-warning',
      tooltip: 'Désactiver',
      condition: (item) => item.enabled
    },
  ];

  constructor(private userService: UserService,
              private faqCategoryService: FaqCategoryService,
              private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.form.controls['categories'].valueChanges.subscribe(event => {
      this.selectCategory(event);
    })
    this.faqCategoryService.getAllCategories().subscribe(cats => {
      this.categories = cats.filter(c => c.slug.length === 2);
      this.question = new FieldDefinition<string[]>({
        key: 'categories',
        label: '',
        type: 'select2',
        placeholder: 'Filtrer par produit',
        options: this.categories,
        value: [],
      });
    });
    this.userService.getCrmUrl().subscribe(url => {
      this.crmUrl = url;
    });
    this.fetchUsers();
  }

  fetchUsers(): void {
    this.userService.listContacts().subscribe(lt => {
      this.load = false;
      this.allContacts = lt;
      // Flatten account name field for searching
      this.allContacts.forEach(c => {
        c.accountName = c.account ? c.account.name : '';
      });
      this.allContacts.sort((a, b) => (a.lastname || '').localeCompare(b.lastname || ''));
      this.contacts = this.allContacts;
    }, () => {
      this.error = true;
    });
  }

  getCategoryFromProduct(p: Product): FaqCategory {
    return this.categories.find(c => {
      return c.slug.toLowerCase() === p.tag.toLowerCase();
    });
  }

  doSearch(): void {
    this.contacts = this.allContacts.filter(c => {
      const s = this.search ? this.search.toLowerCase().trim() : '';
      return (c.accountName && c.accountName.toLowerCase().indexOf(s) !== -1) ||
        (c.email && c.email.toLowerCase().indexOf(s) !== -1) ||
        (c.firstname && c.firstname.toLowerCase().indexOf(s) !== -1) ||
        (c.lastname && c.lastname.toLowerCase().indexOf(s) !== -1);
    });
    if (this.selectedCategory) {
      this.contacts = this.contacts.filter(c => {
        return c.contracts.some(contract => {
          return contract.product.tag.toLowerCase() === this.selectedCategory.slug.toLowerCase();
        });
      });
    }
  }

  selectCategory(cat: FaqCategory): void {
    if(cat) {
      this.selectedCategory = cat[0];
    } else {
      this.selectedCategory = undefined;
    }
    this.doSearch();
  }

  enableUserAsAdmin(): void {
    this.userService.enableUserAsAdmin(this.toActivate).subscribe(uc => {
      this.toActivate.enabled = true;
    });
    this.toastr.success(`L'utilisateur ${this.toActivate.email} a été réactivé`);
  }

  disableUserAsAdmin() : void {
    this.userService.disableUserAsAdmin(this.toDisable).subscribe(uc => {
      this.toDisable.enabled = false;
    });
    this.toastr.success(`L'utilisateur ${this.toDisable.email} a été désactivé`);
  }
}
